import React, { Component } from 'react';
import { Jumbotron, Button, Table, Form, FormGroup, Col, Row, Label, Input, Spinner, Alert } from 'reactstrap';
import { withApollo } from 'react-apollo';
import { GET_AMBASSADORS } from '../../query/query';
import { ADD_AMBASSADOR, RM_AMBASSADOR } from '../../mutation/mutation';

class AmbassadorPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ambassadors: [],
      loading: false,
      error: '',
      email: '',
    };

    this.addAmbassador = this.addAmbassador.bind(this);
    this.removeAmbassador = this.removeAmbassador.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
  }

  getAmbassadors() {
    this.setState({ loading: true });
    this.props.client.query({
      query: GET_AMBASSADORS,
      fetchPolicy: 'no-cache',
    }).then(({ data }) => {
      if (data.savGetAmbassadors) {
        this.setState({
          ambassadors: data.savGetAmbassadors,
          loading: false,
        });
      }
    }).catch((err) => {
      console.log('catch', err);
      alert('An error occured :(');
    });
  }

  addAmbassador() {
    this.setState({ loading: true });
    const { email } = this.state;
    this.props.client.mutate({
      mutation: ADD_AMBASSADOR,
      variables: {
        email,
      },
    }).then(({ data }) => {
      this.setState({ loading: false });
      if (data.savAddAmbassador) {
        this.setState({ error: '' });
        this.getAmbassadors();
      } else {
        this.setState({ error: 'User not found' });
      }
    }).catch((err) => {
      console.log('catch', err);
      alert('An error occured :(');
    });
  }

  removeAmbassador(ambassadorId) {
    this.setState({ loading: true });
    this.props.client.mutate({
      mutation: RM_AMBASSADOR,
      variables: {
        ambassadorId,
      },
    }).then(({ data }) => {
      this.setState({ loading: false });
      if (data.savRemoveAmbassador) {
        this.setState({ error: '' });
        this.getAmbassadors();
      } else {
        this.setState({ error: 'User not found' });
      }
    }).catch((err) => {
      console.log('catch', err);
      alert('An error occured :(');
    });
  }

  handleEmailChange(e) {
    this.setState({
      email: e.target.value,
    });
  }

  componentDidMount() {
    this.getAmbassadors();
  }


  render() {
    const { ambassadors, loading, error } = this.state;
    return (
      <Jumbotron>
        <h3 className="display-4">
          Ambassadors
          {
            loading && (
              <Spinner color="secondary" style={{ position: 'relative', top: -14, left: 14 }}/>
            )
          }
        </h3>
        <Form>
          <FormGroup>
            <Label>Add a new ambassador</Label>
            <Row>
              <Col>
                <Input
                  type="email"
                  value={this.state.email}
                  onChange={this.handleEmailChange}
                />
              </Col>
              <Col>
                <Button
                  onClick={this.addAmbassador}
                  color="success"
                >
                  Add
                </Button>
              </Col>
            </Row>
          </FormGroup>
        </Form>
        {
          error !== '' && (
            <Alert color="warning">
              { error }
            </Alert>
          )
        }
        <hr className="my-2" />
        <Table>
          <thead>
            <tr>
              <th>Firstname</th>
              <th>Email</th>
              <th>Language</th>
              <th>Discount code</th>
              <th>Boxes sold</th>
              <th/>
            </tr>
          </thead>
          <tbody>
            {
              ambassadors.map((ambassador) => (
                <tr key={ambassador._id}>
                  <td>{ ambassador.firstname }</td>
                  <td>{ ambassador.email }</td>
                  <td>{ (ambassador.language || '-').toUpperCase() }</td>
                  <td>{ ambassador.discountCode }</td>
                  <td>{ ambassador.boxesSold }</td>
                  <td><Button onClick={() => this.removeAmbassador(ambassador._id)} color="danger">Delete</Button></td>
                </tr>
              ))
            }

          </tbody>
        </Table>
      </Jumbotron>
    );
  }
}

export default withApollo(AmbassadorPage);



// WEBPACK FOOTER //
// ./src/components/ambassador/ambassador.js